import * as React from 'react';
export const EUSvg = React.forwardRef(function EUSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M8 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm2.5 1.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM12 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM5.5 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm2.5-1.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-5 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM4 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
      }),
    ),
  );
});
EUSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var EU = {
  category: 'flag',
  colorable: false,
  name: 'EU',
  svg: EUSvg,
};
